// 入口文件
import Vue from "vue";
import VueRouter from "vue-router";
import Uikit from "./untils/uikit";
Vue.use(Uikit);
import $ from "jquery";

import * as _ from "lodash";
import { nanoid } from 'nanoid'
import moment from "moment"
//bootstrap (前台,後臺)
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/css/bootstrap-grid.css";
import "./assets/css/adminlte/adminlte.css"; //对bootstrap的一些补充
//视频播放器
import VideoPlayer from "vue-video-player";

import "videojs-flash";
// import 'videojs-contrib-hls';

import "./assets/js/main";
// import "vue-video-player/node_modules/video.js/dist/video-js.css";
// import "vue-video-player/src/custom-theme.css";
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')


import VueResource from "vue-resource";

// 请求拦截与axios封装
import { post, fetch, patch, put, get } from "./api/httpApi/http";
import base from "./api/httpApi/base";

//管理后台
import "./assets/backJs/jquery-3.4.1.min.js";
// import './assets/css/mobile/m-main.js'
//7.21調整css注釋掉了
// import './assets/backJs/adminlte.min.js'
// import './assets/plugins/bs-custom-file-input/bs-custom-file-input.min'
// import "./assets/plugins/datatables/jquery.dataTables.js";
// import "./assets/plugins/datatables-bs4/js/dataTables.bootstrap4.js";

import api from "./api/httpApi/index";
import VueWechatTitle from "vue-wechat-title";
// 组件状态管理
import { store } from "./store/store";
import vuex from "vuex";

import App from "./App"; // 导入app.vue根组件
import router from "./router/index";
//elementui
import ElementUI, { Message } from "element-ui";
import { message } from "element-ui";
//import 'element-ui/lib/theme-chalk/index.css'
import "./assets/theme/element/index.css";
// import locale from "element-ui/lib/locale/lang/zh-TW";
import locale from "element-ui/lib/locale";

Vue.prototype.$loading = ElementUI.Loading.service;
//引入vue懒加载
import VueLazyload from "vue-lazyload";
//引入elementUI動態表單組件
import formCreate from "@form-create/element-ui";
import FcEditor from "@form-create/component-wangeditor";
// 网络请求框架
import axios from "axios";
import Meta from "vue-meta";
//圖片相關
import VueCropper from "vue-cropper";

import VueSocialSharing from "vue-social-sharing";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Mixin from "./assets/js/tools.js";
import socket from "./assets/js/websocketTools";
import socketcopy from "./assets/js/websocketToolscopy";
import "./assets/css/emojionearea.min.css";
import * as cookie from "./untils/cookie.js";

import VueI18n from 'vue-i18n'
// 引入语言文件（需要对哪些内容进行翻译就在文件中写入哪些内容）
import zh from './assets/i18n/zh'
import en from './assets/i18n/en'

import VueCookie from 'vue-cookie'

import { init,SetredisCache } from './assets/js/rediscache.js'

// import "uikit/dist/css/uikit.min.css";
// import "uikit/dist/js/uikit-icons.min.js";
// import "uikit/dist/js/uikit.min.js";

Vue.use(VueCookie)  // 挂在在全局了

Vue.use(VueI18n);
if (!cookie.getItem("AspNetCoreCulture"))
  cookie.setItem("AspNetCoreCulture", "zh", 1000 * 60 * 60 * 24);
// 创建vuei18n实例（两个配置项:locale，messages）
const i18n = new VueI18n({
  locale: cookie.getItem("AspNetCoreCulture"),
  // 配置语言文件对象
  messages: {
    zh: zh,
    en: en
  },
  silentTranslationWarn: true
});
locale.i18n((key, value) => i18n.t(key, value));

 
import { formatTime, relativeTime } from "./untils/formate";
 
Vue.prototype.$formatTime = formatTime
Vue.prototype.$relativeTime = relativeTime
Vue.prototype.$cookies_ = cookie;
Vue.prototype.$_ = _;
Vue.prototype.$axios = axios;
Vue.prototype.soonnetUrl =
  "https://api.soonnet.org/Account/Acc_Resources/206267/Userlogo_Smail.jpg";
 
// 过滤器
Vue.filter('relativeTime', relativeTime)
Vue.filter('formatTime', formatTime)

//开启用户在线请求
init();

// 正式环境清除所有console.log
// if (process.env.NODE_ENV === 'production') {
//   if (window) {
//     window.console.log = function () {};
//   }
// }
Vue.directive("thumbnail", (el, binding) => {
  checkIfImageExists(binding.value, (is404) => {
    if (is404) {
      el.children[0].style.backgroundColor = "inherit";
      el.style.backgroundImage = "url(" + require(`../src/assets/images/404.png`) + ")";
      el.style.backgroundSize = "contain";
      el.style.backgroundRepeat = "no-repeat";
      el.style.backgroundPosition = "50%";
    }
  })
})

let elementResizeDetectorMaker = require("element-resize-detector");
//监听元素变化
let erd = elementResizeDetectorMaker();
function checkIfImageExists(url, callback) {
  const img = new Image();

  img.onerror = function () {
    // 图片加载失败，可能是404或其他原因
    callback(true); // 参数可以是布尔值表示是否加载失败，也可以是对象包含更多信息
  };

  img.onload = function () {
    // 图片成功加载
    callback(false);
  };

  // 设置图片的src属性开始加载图片
  img.src = url;
}


//监听元素变化
Vue.directive("watermark", (el, binding) => {
    // console.log(el);
  var node;
  function addWaterMarker(parentNode,bool) {
    if (!node) {
      try {
        parentNode.children[0].children[2].style.backgroundRepeat = "no-repeat";
      } catch (error) {
        return;
      }
      node = parentNode.children[0].children[2].cloneNode(true);
    }
    erd.listenTo(parentNode.children[0], function(element) {
      let elh = element.clientHeight;
      let elw = element.clientWidth;
      node && node.remove();
      //  console.log(elh, elw);
      //  354 629
      if (elh <= 355 && elw <= 630) {
        // console.log(elh, elw);
        element.children[2].style.backgroundImage =
          "url(" +
          require(`../src/assets/images/left_logo_84x52${
            bool ? ".gif" : ".png"
          }`) +
          ")";
        node.style.backgroundImage =
          "url(" +
          require(`../src/assets/images/right_logo_54x54${
            bool ? ".gif" : ".png"
          }`) +
          ")";
        node.style.backgroundPosition = `${elw - 54}px ${elh - 84}px`;
      } else {
        element.children[2].style.backgroundImage =
          "url(" +
          require(`../src/assets/images/left_logo_245x147${
            bool ? ".gif" : ".png"
          }`) +
          ")";
        node.style.backgroundImage =
          "url(" +
          require(`../src/assets/images/right_logo_138x138${
            bool ? ".gif" : ".png"
          }`) +
          ")";
        node.style.backgroundPosition = `${elw - 130}px ${elh - 200}px`;
      }
      element.append(node);
    });
  }
  setTimeout(() => {
    try {
      const video_ = el.children[0].children[0];
      video_.addEventListener("play", function(e) {
        addWaterMarker(el, true);
      });
      video_.addEventListener("pause", function(e) {
        addWaterMarker(el, false);
      });
    } catch (error) {
      console.log(error);
    }

    addWaterMarker(el,false);
  }, 1000);
});

//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('real-img', async function (el, binding) {//指令名称为：real-img
    let imgURL = binding.value;//获取图片地址
    if (imgURL) {
        let exist = await imageIsExist(imgURL);
        if (exist) {
            el.setAttribute('src', imgURL);
        } 
    }
})

/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function(url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete == true){
                resolve(true);
                img = null;
            }
        }
        img.onerror = function () {
            resolve(false);
            img = null;
        }
        img.src = url;
    })
}


/*視頻直播 start */

// import VideoPlayer from "vue-video-player";

// require("video.js/dist/video-js.css");

// require("vue-video-player/src/custom-theme.css");

// Vue.use(VideoPlayer);
/*視頻直播 end */

Vue.use(VueLazyload, {
  loading: require("../src/assets/images/loading.gif"),
  error: require("../src/assets/images/loading.gif"),
  dispatchEvent: true,
  attempt: 1
});
Vue.use(VueSocialSharing);
Vue.mixin(Mixin);

//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$baseUrl = base;
Vue.prototype.$get = get;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$message = message;
Vue.prototype.$shareUrl =
  "https://www.facebook.com/sharer/sharer.php?src=sdkpreparse&u=";
Vue.prototype.$defaultUserLog =
  "this.src='https://api.soonnet.org/Userlogo_Smail.jpg'";



Vue.use(Meta);
Vue.use(VueRouter);
Vue.use(VueWechatTitle);
Vue.use(ElementUI);
// Vue.use(Skeleton);
// Vue.use(SkeletonItem);
//使用formCreate動態創建表單
formCreate.component("editor", FcEditor);
Vue.use(formCreate);
Vue.use(VideoPlayer);
Vue.use(VueResource);
Vue.use(VueCropper);
Vue.use(VueQuillEditor);


Vue.config.productionTip = false;
// 引入axios
Vue.prototype.$api = api; // 将api挂载到vue的原型上
//组件跳转回到页面顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
//测试开始
// 假设我们有一个URL列表
// const urls = [...Array(100000).keys()].map(i => `ws://172.16.3.120:21023/sid?sid=${nanoid()}`);

// 创建一个函数来初始化WebSocket连接
// function createWebSocketConnection(url) {
//   const socket = new WebSocket(url);
  
//   // 添加必要的事件监听器
//   socket.addEventListener('open', () => console.log(`WebSocket to ${url} opened.`));
//   socket.addEventListener('message', (event) => console.log(`Received message from ${url}:`, event.data));
//   socket.addEventListener('error', (error) => console.error(`Error with WebSocket to ${url}:`, error));
//   socket.addEventListener('close', () => console.log(`WebSocket to ${url} closed.`));

//   return socket;
// }

// 开启1000个WebSocket连接
// const sockets = urls.map(url => createWebSocketConnection(url));

// 存储sockets以便后续操作
// Vue.prototype.$sockets = sockets;
//测试结束
// console.log(window.location.href);
// for (let index = 0; index < 100; index++) {
//  window.open(window.location.href)
// }
const initMeta = {
  keywords: "運動相,運動攝影,追焦相,重機相片,運動平台",
  description:
    "Soonnet尋寶網 最多元、生動的運動休閒平台。我們，專注創造體育賽事中最直接的感動。提供如臨其境的專業優質影音、相片等服務，完整串聯體育愛好者的新媒體網絡。",
  thumbnail: ""
};
router.beforeEach((to, from, next) => {
  if (localStorage.getItem("userinfo")) {
    store.state.customer = JSON.parse(localStorage.getItem("userinfo"));
    if (store.state.customer != null || store.state.customer != "") {
      store.state.permission.Istoken = true;
      store.state.permission.token = store.state.customer.accessToken;
    }
  }
  //store数据持久化
  // 在页面加载时读取sessionStorage
  if (sessionStorage.getItem("store")) {
    store.replaceState(
      Object.assign(
        {},
        store.state,
        JSON.parse(sessionStorage.getItem("store"))
      )
    );
  }

  //this.initWebSocket();
  let head = document.getElementsByTagName("head");
  let meta = document.createElement("meta");
  document
    .querySelector('meta[name="keywords"]')
    .setAttribute("content", initMeta.keywords);
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", initMeta.description);
  document
    .querySelector('meta[name="thumbnail"]')
    .setAttribute("content", initMeta.thumbnail);
  meta.content = initMeta;
  head[0].appendChild(meta);

  if (
    to.path.toLowerCase().indexOf("admin") === -1 &&
    to.name !== "admin" &&
    to.name !== "login"
  ) {
    //暂时关闭 Websocket 未来打开 注意
    // socket.initWebsocket();
  }
  //  if (to.name === "adminIndex") {
  //   socket.initWebsocket(2)
  // } 
  if (
    to.meta.customerNeedLogin != null &&
    to.meta.customerNeedLogin &&
    to.path != "/customerLogin"
  ) {
    if (localStorage.getItem("userinfo")) {
      next();
    } else {
      next({
        path: "/customerLogin",
        query: { redirect: from.fullPath } // 将要跳转路由的path作为参数，传递到登录页面
      });
    }
  } else {
    next();
  }
});

Vue.directive("blur", {
  bind(el, binding, vnode) {
    el.onmouseup = function(e) {
      var t = e;
      if (e.toElement == "span") {
        t = e.target.parentElement;
      }
      t.target.blur();
    };
  },
  inserted(el, binding, vnode) {}
});

/* eslint-disable no-new */
/*
将app根组件挂载到index页面的#app部分
*/
var vue = new Vue({
  router,
  el: "#app",
  store: store,
  i18n,
  // render:h=>h(App)
  components: { App },
  template: "<App/>",
  beforeCreate() {
    Vue.prototype.$bus = this;
  }
});
export default vue;
//路由守卫,实例配置在上面，路由拦截在下面  路由拦截判断是否需要登录
router.onReady(() => {
  router.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    if (to.meta.requireAuth) {
      // 判断该路由是否需要登录权限

      if (store.state.permission.Istoken) {
        // 通过vuex state获取当前的token是否存在
        next();
      } else {
        next("/login");
      }
    } else {
      next();
    }
  });
});



// WEBPACK FOOTER //
// ./src/main.js